(function(){
  angular.module('edxComponents')
    .component('edxCreateQuantileAssignmentLink', {
      templateUrl: '/resources/components/assign-focus/create-quantile-assignment/create-quantile-assignment-link.component.html',
      controller: ['navigation', CreateQuantileAssignmentLinkController],
      controllerAs: 'vm',
      bindings: {}
    });

  function CreateQuantileAssignmentLinkController(navigation) {
    var vm = this;
    vm.onClick = onClick;

    function onClick() {
      navigation.go('.', {
        'assign': 'true',
        'pane': 'create_quantile_assignment'
      });
    }
  }
})();
